<div style="padding: 15px 0px;">
  <div data-test-id="radioButtonVerticalQuestion" [innerHTML]="question.content.text | replacePatientTerm : question.content.patientTerms : patientTerm! | sanitizeHtml"></div>
  <mat-radio-group aria-labelledby="example-radio-group-label" class="radio-group">
    <mat-radio-button class="radio-button" *ngFor="let answer of question.answers" [value]="answer" [checked]="answer.selected" (change)="saveSelection(answer)">
      
      <div class="radio-button__content">
        {{answer.content.text | replacePatientTerm : answer.content.patientTerms : patientTerm!}}
        <div class="radio-button__content--textbox" *ngIf="answer.scaleValue === '996'" style="display: inline-block;margin-left: 5px;">
          <input 
            matInput 
            type="text" 
            [ngClass]="{'radio-button__content--textbox__error': !isOtherTextboxValid}"
            
            [ngModel]="question.responseText" 
            (ngModelChange)="updateOtherTextBoxValidity($event)"
            (focusout)="saveOtherTextBoxAnswer()" 
            #myTextArea 
            [disabled]="isOtherTextBoxDisabled" 
            maxlength="{{this.maxOtherAnswerCount}}" 
            placeholder="{{this.otherAnswerPlaceholder}}"
          >
          <!-- Error Message -->
          <ng-container *ngIf="!isOtherTextboxValid">
            <ng-container *ngFor="let validation of validation_msgs.otherTextboxInputControl">
              <div i18n class="radio-button__content--error-message">  
                {{validation.message}}
              </div>
            </ng-container>
          </ng-container>
  
        </div>
      </div>
      
    </mat-radio-button>
  </mat-radio-group>
  <mat-divider></mat-divider>
</div>